import {
    LIST_TURNS,
    LIST_TURNS_SUCCESS,
    LIST_TURNS_ERROR,
    ADD_TURNS,
    SAVE_TURNS,
    SAVE_TURNS_SUCCESS,
    SAVE_TURNS_ERROR,
    EDIT_TURNS,
    UPDATE_TURNS,
    UPDATE_TURNS_SUCCESS,
    UPDATE_TURNS_ERROR,
    DELETE_TURNS,
    DELETE_TURNS_SUCCESS,
    DELETE_TURNS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    turns: null,
    actualPage: null,
    isLast: null,
    isFirst: null,
    total: null,
    totalPages: null,
    error: null,
    loading: false,
    turnSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_TURNS:
            return {
                ...state,
                loading: true
            }
        case LIST_TURNS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_TURNS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                turns: action.payload.content,
                actualPage: action.payload.number,
                isLast: action.payload.last,
                isFirst: action.payload.first,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages
            }
        case SAVE_TURNS:
        case DELETE_TURNS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_TURNS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_TURNS_ERROR:
        case UPDATE_TURNS_ERROR:
        case DELETE_TURNS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_TURNS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                turns: [...state.turns, action.payload]
            }
        case ADD_TURNS:
            return {
                ...state,
                turnSelected: null,
                isEdit: false
            }
        case EDIT_TURNS:
            return {
                ...state,
                turnSelected: action.payload,
                isEdit: true
            }
        case UPDATE_TURNS_SUCCESS:
        case DELETE_TURNS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                turns: state.turns.map(turn => 
                    turn.id === action.payload.id ? turn = action.payload : turn
                ),
                turnselected: null
            }
        // case DELETE_TURNS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         turns: state.turns.filter( turn => turn.id !== action.payload)
        //     }
        default:
            return state;
    }
}